import { Modal } from 'react-bootstrap'
import { CustomButton } from '../../../../components/CustomButton'
import { formatDate } from '../../../../utils/formatDate'
import { getValue } from '../../../../utils/getValue'

export function ModalInfo({ isOpen, onClose, os }) {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Detalhes</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          <strong>Endereço Origem:</strong> {getValue(os.endereco_origem)}
        </p>

        <p>
          <strong>Produto (SKU):</strong> {getValue(os.sku)}
        </p>

        <p>
          <strong>Endereço Destino:</strong> {getValue(os.endereco_destino)}
        </p>

        <p>
          <strong>Tipo Operação:</strong> {os.descricao_operacao}
        </p>

        <p>
          <strong>Tipo O.S:</strong> {os.descricao_tipoos}
        </p>

        <p>
          <strong>Transação:</strong> {os.numtrans}
        </p>

        <p>
          <strong>Data:</strong> {formatDate(os.data)}
        </p>

        <p>
          <strong>Data Início O.S:</strong>{' '}
          {getValue(formatDate(os.datainicioos))}
        </p>

        <p>
          <strong>Data Fim O.S:</strong> {getValue(formatDate(os.datafimos))}
        </p>

        <p>
          <strong>Observações:</strong> {getValue(os.obs)}
        </p>
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          isDelete
          onClick={onClose}
        >
          Fechar
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
